import axios from 'axios'
import { getHeader, queryBuilder, urlMapper } from '../helpers/utility'

const authDelete = ({ url = '', query = {}, body = {}, params = {} }) => {
  const queryString = queryBuilder(query)
  const mappedUrl = urlMapper(url, params)
  const combinedUrl = `${mappedUrl}${queryString}`

  return axios
    .delete(combinedUrl, { headers: getHeader(), data: body })
    .catch(error => {
      if (error.response) {
        throw error.response
      } else {
        throw error
      }
    })
    .then(response => {
      return response
    })
}

export default authDelete
